module.exports = __webpack_public_path__ + "img/kalalla_joella.19d42dfc.jpg";